export default __webpack_public_path__ + "static/media/BumpFund_Icons_02.ea1e85e8.svg";